import React from 'react'
import useBoardContext from './useBoardContext'
import { BoardContextProps } from './types'

const withBoardContext = <WrappedProps extends BoardContextProps>(
  WrappedComponent: React.ComponentType<WrappedProps>
) => {
  const displayName = WrappedComponent.displayName || WrappedComponent.name || 'Component'

  const WithBoardContext = React.forwardRef<typeof WrappedComponent, Omit<WrappedProps, keyof BoardContextProps>>((props, ref) => {
    const boardContext = useBoardContext()

    return (
      <WrappedComponent
        {...props as WrappedProps}
        ref={ref}
        boardContext={boardContext}
      />
    )
  })

  WithBoardContext.displayName = `withBoardContext(${displayName})`

  return WithBoardContext
}

export default withBoardContext

